import React, { useImperativeHandle } from 'react';
import { useFormik, FormikProvider, FieldArray } from 'formik';

// mui
import { Grid } from '@mui/material';

// components
import FormSectionHeader from '../../../../../components/forms/FormSectionHeader/FormSectionHeader.component';
import FormDataPoint from '../../../../../components/forms/FormDataPoint/FormDataPoint.component';
import CrewAssignment from '../../../../../components/forms/lists/CrewAssignment/CrewAssignment.component';


const CREW_MEMBER_CLASS_CHOICES = {
    J: 'Journeyman',
    Y: 'Yard',
    A_1: 'A1',
    A_2: 'A2',
    A_3: 'A3',
    A_4: 'A4',
    A_5: 'A5',
    A_6: 'A6',
    A_7: 'A7',
    A_8: 'A8',
    F: 'Foreman',
    S: 'Superintendent',
    A: 'Admin',
    C: 'Clerk',
}

const UpdateTimeTicketState = React.forwardRef(({ prefillData = null, errors}, ref) => {

    useImperativeHandle(ref, () => ({
        getData: () => { return formik.values }
    }))

    const formik = useFormik({
        initialValues: prefillData ? {...prefillData} : {
        }
    })

    return (
        <FormikProvider value={formik}>
            <form onSubmit={formik.handleSubmit}>
                <FormDataPoint label='Job' value={prefillData['jobDay'] ? prefillData.jobDay.job.name : "Unknown"} />
                <FormDataPoint label='Scope' value={prefillData['jobDay'] ? prefillData.jobDay.scopeOfWork : "Unknown"}  />

                <Grid container>
                    <Grid item xs={12}>
                        <FormSectionHeader text='Crew Assignments' />
                    </Grid>
                    <Grid container>
                        {
                            prefillData.assignments && prefillData.assignments.map((assignment, index) => {
                                return <CrewAssignment
                                    key={index}
                                    variant='approve-time-tickets'
                                    data={{
                                        title: `${assignment.crewMember.firstName} ${assignment.crewMember.lastName}`,
                                        subTitle: CREW_MEMBER_CLASS_CHOICES[assignment.crewMember.classification],
                                        isGood: assignment.signOff !== null,
                                        rightLabelGood: "Signed",
                                        rightLabelBad: "Not Signed"
                                    }}
                                />
                            })
                        }
                    </Grid>
                </Grid>
            </form>

            
        </FormikProvider>
    )
})

export default UpdateTimeTicketState